import { render, staticRenderFns } from "./px-textarea.vue?vue&type=template&id=28de2042&scoped=true&"
import script from "./px-textarea.vue?vue&type=script&lang=ts&"
export * from "./px-textarea.vue?vue&type=script&lang=ts&"
import style0 from "./px-textarea.vue?vue&type=style&index=0&id=28de2042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28de2042",
  null
  
)

export default component.exports